import { format, addDays } from "date-fns";

const DAY_LETTERS = {
  MONDAY: "M",
  TUESDAY: "T",
  WEDNESDAY: "W",
  THURSDAY: "T",
  FRIDAY: "F",
  SATURDAY: "S",
  SUNDAY: "S",
};

export function WeekDayStrip({
  dayOrder,
  weekStart,
  currentDayIndex,
  onSelectDay,
  todayIndexInWeek,
  populatedDays,
  isPastWeek,
}) {
  return (
    <div className="grid grid-cols-7 gap-1 px-1 py-2 bg-white border-b border-gray-200">
      {dayOrder.map((dayCode, index) => {
        const date = addDays(weekStart, index);
        const isSelected = index === currentDayIndex;
        const isToday = index === todayIndexInWeek;
        const isPopulated = populatedDays.has(dayCode);

        return (
          <button
            key={dayCode}
            onClick={() => onSelectDay(index)}
            className="flex flex-col items-center gap-1 py-1 rounded-lg"
          >
            <span
              className={`text-[10px] font-medium uppercase ${
                isSelected && !isPastWeek ? "text-gray-900" : "text-gray-400"
              }`}
            >
              {DAY_LETTERS[dayCode]}
            </span>
            <span
              className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-medium transition-colors ${
                isSelected && isPastWeek
                  ? "bg-gray-300 text-gray-500"
                  : isSelected
                  ? "bg-gray-900 text-white"
                  : isToday
                  ? "text-gray-900 ring-1 ring-gray-900"
                  : isPastWeek
                  ? "text-gray-400"
                  : "text-gray-900"
              }`}
            >
              {format(date, "d")}
            </span>
            <span
              className={`w-1 h-1 rounded-full ${
                isPopulated
                  ? isSelected && !isPastWeek
                    ? "bg-gray-900"
                    : "bg-gray-300"
                  : "bg-transparent"
              }`}
            />
          </button>
        );
      })}
    </div>
  );
}
